export default {
  groupName: 'fidelity',
  appName: 'Fidelity',
  baseRoute: '/dashboard/fidelity',
  image: 'fidelity.png',
  description: 'Fidelity Advertising Dashboard',
  label: 'Advertising Dashboard',
  home: '/slicer'
}



// WEBPACK FOOTER //
// ./src/app/configuration/FidelityV2/config/main.js